module.exports = __webpack_public_path__ + "static/media/email-otp-consent-logo.9b78d3be.png";